import { useEffect, useState } from 'react';
import devLogger from 'react-utils/devLogger'; // eslint-disable-next-line no-restricted-imports

import userInfo from 'hub-http/userInfo';
export const useUserInfo = () => {
  const [userInfoResponse, setUserInfoResponse] = useState();
  useEffect(() => {
    try {
      // ignoreRedirect is important! Without it, any consumers of CDP that don't
      // support or shim userInfo can end up redirecting (the default behavior).
      // This has caused past critsits:
      // https://git.hubteam.com/HubSpot/Critsit/issues/3557
      // https://git.hubteam.com/HubSpot/Critsit/issues/1040
      userInfo({
        ignoreRedirect: true
      }).then(response => {
        setUserInfoResponse(response);
      }).catch(() => {
        devLogger.warn({
          message: `propertyinputv2-userinfo: API failure fetching userinfo`,
          key: 'propertyinputv2-userinfo-api'
        });
      });
    } catch (err) {
      devLogger.warn({
        message: `propertyinputv2-userinfo: Failure fetching userinfo`,
        key: 'propertyinputv2-userinfo'
      });
    }
  }, []);
  return userInfoResponse;
};